/* アコーディオン開閉：クラスベースで何個でも自動対応 */
(function() {
  function initHowAttach() {
    document.querySelectorAll('.how-attach-summary').forEach(function(summary) {
      summary.addEventListener("click", function() {
        var parent = summary.closest('.how-attach');
        if (parent) parent.classList.toggle("open");
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHowAttach);
  } else {
    initHowAttach();
  }
})();